import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../../app-config';
import { tap } from 'rxjs/operators';
import { TokenStorageService } from '../auth/token-storage.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class EvaluacionService {

  constructor(private http: HttpClient,
              private tokenStorage: TokenStorageService,
              private appConfig:AppConfig
              ) {
                this.API_URL = appConfig.api_url;
              }
  API_URL = "";

  cleanFilter(filtro):any {
      //recibe un json, limpia todos los atributos que sean null, undefined o vacios
        let json = filtro;
        for (var propName in json) {
          if (json[propName] === null || json[propName] === undefined || json[propName] === '') {
            delete json[propName];
          }
        }
        return json;
  }

  count(filtros): Observable<any> {
      let filtro = this.cleanFilter(filtros.value);
    return this.http.post(this.API_URL + 'evaluaciones/count',filtro, httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  getAll(filtros): Observable<any> {
      let filtro = this.cleanFilter(filtros.value);
    return this.http.post(this.API_URL + 'evaluaciones/all',filtro, httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  getConsolidacionesAll(filtros): Observable<any> {
      let filtro = this.cleanFilter(filtros.value);
    return this.http.post(this.API_URL + 'evaluaciones/consolidaciones/all',filtro, httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  getAllMy(filtros): Observable<any> {
      let filtro = this.cleanFilter(filtros.value);
    return this.http.post(this.API_URL + 'evaluaciones/my/all',filtro, httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  countMyVencenHoy(): Observable<any> {
    return this.http.get(this.API_URL + 'evaluaciones/my/count/vencen-hoy', httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  countMyAtrasadas(): Observable<any> {
    return this.http.get(this.API_URL + 'evaluaciones/my/count/atrasadas', httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  countMyEnFecha(): Observable<any> {
    return this.http.get(this.API_URL + 'evaluaciones/my/count/en-fecha', httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }


  statisticsMy(): Observable<any> {
    return this.http.get(this.API_URL + 'evaluaciones/my/count/by-estado', httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  getAllMyConsolidaciones(filtros): Observable<any> {
      let filtro = this.cleanFilter(filtros.value);
    return this.http.post(this.API_URL + 'evaluaciones/my/consolidaciones/all',filtro, httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }

  register(evaluacion): Observable<any> {
    return this.http.post(this.API_URL + 'evaluaciones/add', evaluacion, httpOptions);
  }

  registerConsolidacion(evaluacion): Observable<any> {
    return this.http.post(this.API_URL + 'evaluaciones/consolidacion/add', evaluacion, httpOptions);
  }

  delete(id): Observable<any> {
    return this.http.delete(this.API_URL + 'evaluaciones/' + id, httpOptions);
  }

  deleteControlSugerido(id,controlId): Observable<any> {
    return this.http.delete(this.API_URL + 'evaluaciones/' + id+'/controles-sugeridos/'+controlId, httpOptions);
  }

  deleteKri(id,kriId): Observable<any> {
    return this.http.delete(this.API_URL + 'evaluaciones/' + id+'/kri/'+kriId, httpOptions);
  }

  deleteMedidaDeContingencia(id,medidaId): Observable<any> {
    return this.http.delete(this.API_URL + 'evaluaciones/' + id+'/medida-de-contingencia/'+medidaId, httpOptions);
  }

  deleteConsolidacion(id): Observable<any> {
    return this.http.delete(this.API_URL + 'evaluaciones/consolidacion/' + id, httpOptions);
  }

  deleteRiesgos(id,riesgoId): Observable<any> {
    return this.http.delete(this.API_URL + 'evaluaciones/' + id+'/riesgo/'+riesgoId, httpOptions);
  }

  edit(id, evaluacion): Observable<any> {
    return this.http.put(this.API_URL + 'evaluaciones/' + id, evaluacion, httpOptions);
  }

  get(id): Observable<any> {
    return this.http.get(this.API_URL + 'evaluaciones/' + id, httpOptions);
  }

  editStatus(id, status): Observable<any> {
    return this.http.put(this.API_URL + 'evaluaciones/'+ id+'/status', status, httpOptions);
  }

  editStatusRechazo(id, status,motivo): Observable<any> {
    return this.http.put(this.API_URL + 'evaluaciones/'+ id+'/rechazo', motivo, httpOptions);
  }

  editTipo(id, tipo): Observable<any> {
    return this.http.put(this.API_URL + 'evaluaciones/'+ id+'/tipo', tipo, httpOptions);
  }

  editEstructura(id, estructura): Observable<any> {
    return this.http.put(this.API_URL + 'evaluaciones/'+ id+'/estructura', estructura, httpOptions);
  }

  editOwner(id, owner): Observable<any> {
    return this.http.put(this.API_URL + 'evaluaciones/'+ id+'/owner', owner, httpOptions);
  }

  editEscenario(id, escenario): Observable<any> {
    return this.http.put(this.API_URL + 'evaluaciones/'+ id+'/escenario', escenario, httpOptions);
  }

  editFechaInicio(id, fechaI): Observable<any> {
    return this.http.put(this.API_URL + 'evaluaciones/'+ id+'/fecha-inicio', fechaI, httpOptions);
  }

  editFechaFin(id, fechaF): Observable<any> {
    return this.http.put(this.API_URL + 'evaluaciones/'+ id+'/fecha-fin', fechaF, httpOptions);
  }

  editNombre(id, nombre): Observable<any> {
    return this.http.put(this.API_URL + 'evaluaciones/'+ id+'/nombre', nombre, httpOptions);
  }

  versionar(id): Observable<any> {
    return this.http.get(this.API_URL + 'evaluaciones/'+ id+'/versionar', httpOptions);
  }

  copiar(id, nombre): Observable<any> {

    var httpOptionsLocal = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
      //observe: 'response' as 'body'
    };

    return this.http.post(this.API_URL + 'evaluaciones/'+ id+'/copiar', {}, {...httpOptionsLocal, params:
      {nombre: nombre}
    });
  }

  ///find-by-nodo/{id}
  getByNodoBetweenDates(id,inicio,fin): Observable<any> {

    inicio = inicio.getDate() +"-"+(inicio.getMonth()+1)+"-"+inicio.getFullYear();
    fin = fin.getDate() +"-"+(fin.getMonth()+1)+"-"+fin.getFullYear();

    var httpOptionsLocal = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
      //observe: 'response' as 'body'
    };

    return this.http.post(this.API_URL + 'evaluaciones/find-by-nodo/'+ id, {}, {...httpOptionsLocal, params:
      {inicio: inicio,
       fin: fin}
    });
  }

  getConsolidacion(id): Observable<any> {
    return this.http.get(this.API_URL + 'evaluaciones/consolidacion/' + id, httpOptions);
  }

  countConsolidaciones(filtros): Observable<any> {
      let filtro = this.cleanFilter(filtros.value);
    return this.http.post(this.API_URL + 'evaluaciones/consolidaciones/count',filtro, httpOptions).pipe(tap(evaluacion => {
      return evaluacion;
    }));
  }




}
